import styled from "styled-components";

export const Description = styled.p `
    display: -webkit-box;
    -webkit-box-orient: vertical;


    text-overflow: ellipsis;
    font-size: ${ props => props.size };
    width: 100%;
    
    color: ${ props => props.color }
`;